export default __webpack_public_path__ + "static/media/cerrar.2fce6214.png";